import { Component } from '@angular/core';
import { TagsComponent } from 'components/input/tags/tags.component';
import { TaskflowTemplateModel } from 'models/generated/Entities.GormCrm.TaskflowTemplate';
import { TaskflowTemplateTagModel } from 'models/generated/Entities.GormCrm.TaskflowTemplateTag';
import { TaskTemplateTagModel } from 'models/generated/Entities.GormCrm.TaskTemplateTag';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { TaskflowTemplateService } from 'services/taskflow-template.service';
import { TaskTemplatesComponent } from './task-template.component';
import { Inputs } from 'modules/inputs';
import { ListTaskflowTemplateComponent } from './list-taskflow-template.component';
import { FormValidationService } from 'services/form-validation.service';


@Component({
	selector: 'edit-taskflow-template',
	templateUrl: './edit-taskflow-template.component.html',
	imports: [Layout, Inputs, TagsComponent, TaskTemplatesComponent, TranslatePipe],
	providers: [FormValidationService]
})
@ComponentUrl('edit-taskflow-templates')
export class EditTaskflowTemplateComponent {
	public title = '';
	public taskflowTemplate?: TaskflowTemplateModel;
	taskflowTemplateTags: TaskflowTemplateTagModel[] = [];
	taskTemplateTags: TaskTemplateTagModel[] = [];
	private savingData = false;

	@UrlParam
	set taskflowTemplateId(id: string) {
		if (id && id !== '') {
			this.taskflowTemplateService.getTemplate(id).then(taskflowTemplate => {
				this.loadTaskflowTemplate(taskflowTemplate);
			});
		} else {
			this.loadTaskflowTemplate(new TaskflowTemplateModel());
		}
	}
	get taskflowTemplateId() {
		return this.taskflowTemplate && this.taskflowTemplate.id ? this.taskflowTemplate.id : '';
	}

	constructor(private readonly navigation: NavigationService,
		private readonly taskflowTemplateService: TaskflowTemplateService,
		private readonly translate: TranslatePipe) {
		this.taskflowTemplateService.getAllTaskflowTemplateTags().then(taskflowTemplateTags => this.taskflowTemplateTags = taskflowTemplateTags);
		this.taskflowTemplateService.getAllTaskTemplateTags().then(taskTemplateTags => this.taskTemplateTags = taskTemplateTags);
	}

	loadTaskflowTemplate(taskflowTemplate: TaskflowTemplateModel) {
		this.taskflowTemplate = taskflowTemplate;
		this.title = this.translate.transform(this.taskflowTemplate.id ? 'taskflow.edit-taskflow-template' : 'taskflow.create-taskflow-template');
		this.taskflowTemplate.taskTemplates.sort((a, b) => a.step - b.step);

		this.navigation.refreshUrl();

		this.navigation.openParentView(this, 'edit-taskflow-templates', ListTaskflowTemplateComponent).then(view => view.selectedTaskflowTemplateId = this.taskflowTemplateId);
	}
	
	saveTaskflowTemplate(taskflowTemplate: TaskflowTemplateModel) {
		this.savingData = true;

		taskflowTemplate.include(tt => tt.taskTemplates);
		taskflowTemplate.taskTemplates.forEach(taskTemplate => taskTemplate.include(tt => tt.taskTemplateTags));
		taskflowTemplate.include(tt => tt.taskflowTemplateTags);

		let request: Promise<TaskflowTemplateModel>;
		if (taskflowTemplate.id != undefined) {
			request = this.taskflowTemplateService.updateTemplate(taskflowTemplate);
		} else {
			request = this.taskflowTemplateService.createTemplate(taskflowTemplate);
		}
		request.then((taskflowTemplate) => {
			this.loadTaskflowTemplate(taskflowTemplate);
			this.savingData = false;
		});
	}
	
	dataChanged = false;
	canSave() {
		if (this.savingData) return false;
		if (this.taskflowTemplate) {
			if (this.taskflowTemplate.title == '') return false;
		}
		return true;
	}
}
